import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { CfaService } from "../services/cfa.service";
import { map, catchError, of, delay } from "rxjs";
import { AuthService } from "../services/auth.service";
import posthog from 'posthog-js';

@Injectable({ providedIn: "root" })
export class CfaAuthorPublished {
    constructor(
        private readonly _router: Router,
        private readonly _cfaService: CfaService,
        private readonly _authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this._cfaService.getCfaAuthorState().pipe(
            // delay(2000), //debug slow request
            map((state) => {
                if (state.cid) {
                    posthog.alias(state.cid);
                }
                if (state.published) {
                    return true;
                } else {
                    return this._router.createUrlTree(["/author-page"]);
                }
            }),
            catchError((error) => {
                console.error(error);
                this._authService.logout();
                return of(false);
            })
        );
    }
}
